export const ChevronLeftSmall = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3202 13.3337L8.57611 10.5896C8.25067 10.2641 8.25067 9.73651 8.57611 9.41107L11.3202 6.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChevronLeftSmall
